<template>
  <div class="swimlane-wrap">
    <h3 class="swin-side-head">Scroll of Honor</h3>
    <VueSwimlaneCustome :words="words" :rows="10" :transitionDelay="0" :transitionDuration="1500" transition="linear" :pauseOnHover="true" :scale=2 :continous="true"></VueSwimlaneCustome>
  </div>
</template>

<script>
import VueSwimlaneCustome from "./swimlane-componenet"
export default {
  name: "Swimlane",
  props: {
    value: {
      type: Object,
      default: () => {
        return {donors: []}
      }
    }
  },
  components: {VueSwimlaneCustome},
  computed: {
    words() {
      let donorGroupings = {}
      let words = []
      this.value.donors.map((donor) => {
        var donarHTML
        if (donor.logo.imageURL != "") {
          donarHTML = `<p class="swin-p"">${donor.fullName}</p><img class="swin-image" src="${donor.logo.imageURL}" />`
        } else {
          donarHTML = `<p class="swin-p"">${donor.fullName}</p>`
        }
        if (!donorGroupings[donor.tier.value]) donorGroupings[donor.tier.value] = [donarHTML]
        else donorGroupings[donor.tier.value].push(donarHTML)
      })
      Object.keys(donorGroupings).forEach((key) => {
        words.push(`<h3 class="swin-head">${key}</h3>`)
        words = words.concat(donorGroupings[key])
        words.push('')
      });
      return words
    }
  }
}
</script>

<style>
.swimlane-wrap{
  /* padding: 50px !important; */
  border-radius: 10px;
  background-color: #fff;
  max-width: 1200px;
  width: 90%;
  margin: 30px auto;
  text-align: left !important;
}
.swin-side-head{
    font-family: Merriweather, serif;
    font-size: 32px;
    padding: 60px;
    padding-top: 40px;
    display: inline-block;
    vertical-align: top;
    text-align: left;
    max-width: 380px;
    width: 32%;
    line-height: 40px;
}
.swin-head{
  font-family: Merriweather, serif !important;
  line-height: 10px !important;
  color: #751811;
  font-size: 32px;
  text-align: left;
}
.vue-swimlane{
    display: inline-block;
    border-left: solid 1px rgba(0, 0, 0, 0.16);
    padding-left: 30px;
    margin-left: 20px;
}
.swin-p{
    font-size: 22px !important;
    display: inline-block;

}
.swin-image{
  display: inline-block;
  width: 100px;
  max-height: 40px;
  object-fit: scale-down;
  margin-left: 10px;
}
.vue-swimlane li{
    text-align: left !important;
}
@media screen and (max-width: 768px) {
  .swimlane-wrap{
  text-align: center !important;
}
ul{
  text-align: center !important;
  padding: 0 !important;
}
  .swin-side-head{
    text-align: center;
    font-size: 32px;
    padding: 0px;
    padding-top: 20px;
    max-width: none;
    width: 100%;
    line-height: 40px;
}
.vue-swimlane{
    border-left: none;
    padding: 0;
    margin: 0;
}
.swimlane-wrap li{
    text-align: center !important;
}
}
</style>